import React, { useState, useEffect } from "react";
import "../../assets/css/cms/Cms.css";
import "../../assets/css/globals.css";
import { connect } from "react-redux";
import Loading from "../../components/utils/loader";
import {
  fetchAuthUserPermission,
  fetchUser,
} from "../../../store/actions/user";
import CMSRoutes from "../../routes/cms";
import DesktopHeader from "../../components/cms/ui/DesktopHeader";
import Navbar from "../../components/cms/ui/Navbar";
import CmsLogin from "./login";
import { useLocation } from "react-router-dom";
// import CMSDashboard from "../../components/cms/dashboard/index"
const CmsHome = (props) => {
  const location = useLocation();

  useEffect(() => {
    props.dispatch(fetchUser());
    if (!location.pathname.includes("comment-moderation")){
      localStorage.removeItem("commentModerationFilters");
    }
  }, []);
  
  useEffect(() => {
    if (props._user) {
      if (props._user && !props._user?.data?.is_staff) {
        window.location.href = "/";
      }
      props.dispatch(fetchAuthUserPermission());
    }
  }, [props._user]);
  useEffect(() => {
    if (props._user_error) {
      if (props.location != "/cms/login") window.location.href = "/cms/login";
    }
  }, [props._user_error]);
  if (props.location === "/cms/login") {
    return <CmsLogin user={props._user} permission={props._user_permission} />;
  }
  if (props._user && props._user?.data?.is_staff) {
    return (
      <div>
        <DesktopHeader user={props._user && props._user.data} extraParams={props.extraParams}
          setIframeUrl={(obj) => props.setIframeUrl(obj)} />
        <Navbar
          user={props._user && props._user.data}
          permission={props._user_permission}
        />
        <div className={"cms_wrap"}>
          {props._user && props._user_permission && (
            <CMSRoutes user={props._user} permission={props._user_permission} />
          )}
            {/* <CMSDashboard/> */}
        </div>
      </div>
    );
  }
  return <Loading />;
};
const mapStateToProps = (state) => {
  return {
    _loading: state.userData?.loading,
    _user_permission: state.userData?.userPermission,
    _user: state.userData.user,
    _user_error: state.userData.user_error,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CmsHome);